import { getPrivateApi } from "../lib/axiosConfig";
import { VehicleInfo, WashingStatus } from "../types/vehicle.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/operator"

export const getLicensePlateInfos = async (licensePlate: string): Promise<VehicleInfo> => {

  try {
    const { data: vehicleInformation } = await api.get(`${endpoint}/${licensePlate}/infos`)

    return vehicleInformation;
  } catch (error: any) {
    const errMsg = "Erro ao buscar informações do veículo";

    console.error(errMsg, error?.response ?? error);

    const message = error?.response?.data?.message ?? errMsg;

    throw new AppError(message, error.status);
  };
};

export const getWashingStatus = async (licensePlate: string): Promise<WashingStatus[]> => {
  try {
    const { data } = await api.get(`/washing-status/${licensePlate}`);
    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar status de lavagem";
    console.error(errMsg, error?.response ?? error);
    const message = error?.response?.data?.message ?? errMsg;
    throw new AppError(message, error.status);
  }
};

